<template>
    <div class="ticket-banner">
        <van-swipe class="my-swipe" ref="swipe" :width="width">
            <van-swipe-item v-for="(item, index) in bannersList" :key="index">
                <div class="swiper-slide">
                    <img :src="item.coverImg + '?x-oss-process=image/resize,s_400'" @click="toDetail(item)">
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
require('@/assets/css/public/ticketsBanners.scss');
export default {
    name: 'Banners',
    data () {
        return {
            banner: {},
            home: 'Ticket',
            width: null
        };
    },
    props: ['bannersList', 'from'],
    mounted () {
        this.width = this.$refs.swipe.size + 10;
        this.$refs.swipe.resize();
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem
    },
    methods: {
        toDetail (item) {
            let page = '';
            window._czc = window._czc || [];
            if (this.from === 'ticket') {
                window._czc.push(['_trackEvent', '演出首页', 'TICKET_BANNER_CLICK_EVENT', '轮播banner']);
            } else if (this.from === 'mall') {
                this.home = 'Mall';
                window._czc.push(['_trackEvent', '商城', 'MALL_BANNER_CLICK_EVENT', '轮播banner']);
            }
            switch (item.targetType) {
            case 1:
                this.$router.push({
                    path: '/media/pgcvideo',
                    name: 'pgcvideo',
                    query: {
                        videoId: item.jump_id
                    }
                });
                break;
            case 6:
                page = this.home + 'TicketBanner';
                this.$TD.header(page);
                this.$TD.funnel('click_ticketBanner');
                this.$router.push({
                    path: '/ticket/detail',
                    name: 'TicketDetail',
                    query: {
                        id: item.targetObj
                    }
                });
                break;
            case 7:
                page = this.home + 'GoodBanner';
                this.$TD.header(page);
                this.$TD.funnel('click_goodBanner');
                this.$router.push({
                    path: '/mall/detail',
                    name: 'MallGoodDetail',
                    query: {
                        id: item.targetObj
                    }
                });
                break;
            case 8:
                page = this.home + 'TourBanner';
                this.$TD.header(page);
                this.$TD.funnel('click_tourBanner');
                this.$router.push({
                    path: '/ticket/tour',
                    name: 'TourList',
                    query: {
                        id: item.targetObj
                    }
                });
                break;
            case 12:
                window.location.href = item.targetObj;
                break;
            case 14:
                this.$router.push({
                    path: '/mall/theme',
                    name: 'MallTheme',
                    query: {
                        id: item.targetObj
                    }
                });
                break;
            case 26:
                this.$cookie.set('vipRedirect', this.$route.fullPath);
                this.$router.push({
                    path: '/user/vip',
                    name: 'MVip',
                    query: {
                        jumpType: 'quickVip'
                    }
                });
                break;
            case 100:
                window.location.href = item.targetObj;
                break;
            };

            // if (item.jump_type === 6) {
            //     this.$router.push({
            //         path: '/ticket/detail',
            //         name: 'TicketDetail',
            //         query: {
            //             id: item.id
            //         }
            //     });
            // } else if (item.jump_type === 8) {
            //     this.$router.push({
            //         path: '/ticket/tour',
            //         name: 'TourList',
            //         query: {
            //             id: item.id
            //         }
            //     });
            // } else if (item.jump_type === 7) {
            //     this.$router.push({
            //         path: '/mall/detail',
            //         name: 'MallGoodDetail',
            //         query: {
            //             id: item.id
            //         }
            //     });
            // }
        }
    }
};
</script>